module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.fc17ea62.ttf";